import {
  CheckboxInput,
  DateSelectorInput,
  RadioInput,
  useFormContext,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { useEffect } from "react";
import styles from "./DateRange.module.scss";

const cx = classNames.bind(styles);

interface DateRangeSectionProps {
  isDisabled?: boolean;
  preventFutureDates?: boolean;
}

export const DateRange = (inputProps: DateRangeSectionProps) => {
  const form = useFormContext();

  const { hasDateRange, hasDateRangeStart, hasDateRangeEnd } = form.watch();

  // Remove dateRange from form values when start or end checkboxes change:
  useEffect(() => {
    form.setValue("dateRange", undefined);
  }, [hasDateRangeStart, hasDateRangeEnd]);

  // Remove checkbox states when changing date range radio:
  useEffect(() => {
    if (!hasDateRange) {
      form.setValue("hasDateRangeStart", undefined);
      form.setValue("hasDateRangeEnd", undefined);
    }
  }, [hasDateRange]);

  const hasDateRangeStartAndEnd =
    hasDateRange && hasDateRangeStart && hasDateRangeEnd;

  const rangePickerLabel = hasDateRangeStartAndEnd
    ? "Date Range"
    : hasDateRangeStart
      ? "Start Period"
      : hasDateRangeEnd
        ? "End Period"
        : "";

  // Set max date to today to prevent future dates if flag is enabled
  const maxDate = inputProps.preventFutureDates ? new Date() : undefined;

  return (
    <fieldset className={cx("date-range-fieldset")}>
      <p className={cx("title")}>Date Range</p>
      <RadioInput
        {...inputProps}
        name="hasDateRange"
        labelKey="label"
        valueKey="value"
        options={[
          { label: "Set values for all time", value: false },
          { label: "Define range for values", value: true },
        ]}
        onChange={(val) => form.setValue("dateRange", val)}
      />
      {hasDateRange && (
        <>
          <div className={cx("checkbox-container")}>
            <CheckboxInput
              {...inputProps}
              name="hasDateRangeStart"
              label="Define Start Period"
              isLabelShown={false}
              isFluid
              className={cx("date-range-checkbox")}
            />
            <CheckboxInput
              {...inputProps}
              name="hasDateRangeEnd"
              label="Define End Period"
              isLabelShown={false}
              isFluid
              className={cx("date-range-checkbox")}
            />
          </div>
          {(hasDateRangeStart || hasDateRangeEnd) && (
            <DateSelectorInput
              {...inputProps}
              variant="month"
              isRange={!!hasDateRangeStartAndEnd}
              name="dateRange"
              label={rangePickerLabel}
              isFluid
              isRequired
              hasNextPrevButtons={false}
              max={maxDate}
            />
          )}
        </>
      )}
    </fieldset>
  );
};
